function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "Layer_1",
  width: "24",
  height: "24",
  x: "0",
  y: "0",
  version: "1.1",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Icon_Design_-_Merged"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.5 14h-4c-.3 0-.5.2-.5.5v4c0 .3.2.5.5.5h4c.3 0 .5-.2.5-.5v-4c0-.3-.2-.5-.5-.5zm-.5 4h-3v-3h3v3z",
  className: styles["st1"] || "st1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.7 6l-2-4.1c-.2-.6-.8-.9-1.3-.9H3.6c-.5 0-1.1.3-1.3.8L.3 6C-.4 7.4.2 9 1.6 9.7c.1.1.3.1.4.2v12.6c0 .3.2.5.5.5h19c.3 0 .5-.2.5-.5V9.9c1.5-.4 2.3-2 1.9-3.5-.1-.1-.1-.3-.2-.4zM3.6 2h16.7c.2 0 .4.1.5.3l.4.7H2.8l.3-.7c.2-.2.3-.3.5-.3zM12 14H5c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2m-1 1v7H6v-7h5zm1 7v-7c.6 0 1-.4 1-1 0-1.7-1.3-3-3-3H7c-1.7 0-3 1.3-3 3 0 .6.4 1 1 1v7H3V10c.8-.1 1.6-.5 2.1-1.2.9 1.3 2.6 1.6 3.9.7.3-.2.5-.4.7-.7.9 1.3 2.6 1.6 3.9.7.3-.2.5-.4.7-.7.9 1.3 2.6 1.6 3.9.7.3-.2.5-.4.7-.7.5.7 1.3 1.1 2.1 1.2v12h-9zM22.9 7.7c-.2.6-.6 1.1-1.2 1.2-.9.3-1.9-.2-2.2-1.1l-.1-.3c0-.3-.2-.5-.5-.5s-.5.2-.5.5l-.1.3c-.3.9-1.4 1.4-2.3 1.1-.5-.2-.9-.6-1.1-1.1l-.1-.3c0-.3-.2-.5-.5-.5s-.5.2-.5.5l-.1.3c-.3.9-1.4 1.4-2.3 1.1-.5-.2-.9-.6-1.1-1.1l-.1-.3c0-.3-.2-.5-.5-.5s-.5.2-.5.5l-.1.3c-.4 1-1.4 1.4-2.3 1.1-.5-.2-.9-.6-1.1-1.1l-.1-.3c0-.3-.2-.5-.5-.5s-.5.2-.5.5l-.1.3c-.3.9-1.3 1.4-2.2 1.1-.6-.1-1.1-.6-1.2-1.2-.2-.4-.1-.9.1-1.3L2.4 4h19.3l1.2 2.4c.1.4.2.9 0 1.3z",
  className: styles["st1"] || "st1"
})));